export type InternalAssigneeLike = {
  assignedAgentDisplayName?: unknown;
  assignedAgentFirstName?: unknown;
  assignedAgentLastName?: unknown;
  assignedAgentEmail?: unknown;
  assignedAgentPhotoURL?: unknown;
  assignedAgentId?: unknown;
  assignedTo?: unknown;
};

function clean(value: unknown): string {
  return typeof value === 'string' ? value.trim() : String(value ?? '').trim();
}

export type ResolvedInternalAssigneeIdentity = {
  id: string | null;
  firstName: string | null;
  lastName: string | null;
  name: string;
  email: string | null;
  photoURL: string | null;
  isAssigned: boolean;
};

export function resolveInternalAssigneeIdentity(
  source: InternalAssigneeLike | null | undefined,
  fallback = '\u2014',
): ResolvedInternalAssigneeIdentity {
  const firstName = clean(source?.assignedAgentFirstName) || null;
  const lastName = clean(source?.assignedAgentLastName) || null;
  const displayName = clean(source?.assignedAgentDisplayName);
  const email = clean(source?.assignedAgentEmail) || null;
  const photoURL = clean(source?.assignedAgentPhotoURL) || null;
  const assignedTo = clean(source?.assignedTo);
  const id = clean(source?.assignedAgentId) || null;

  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  const name =
    displayName ||
    fullName ||
    email ||
    (assignedTo && assignedTo !== id ? assignedTo : '') ||
    id ||
    assignedTo ||
    fallback;

  return {
    id,
    firstName,
    lastName,
    name,
    email,
    photoURL,
    isAssigned: Boolean(id || displayName || fullName || email || assignedTo),
  };
}

export function resolveInternalAssigneeDisplay(
  source: InternalAssigneeLike | null | undefined,
  fallback = '\u2014',
): string {
  return resolveInternalAssigneeIdentity(source, fallback).name;
}

export function resolveInternalAssigneeSortValue(
  source: InternalAssigneeLike | null | undefined,
): string {
  return resolveInternalAssigneeDisplay(source, '').toLowerCase();
}
